<template>
  <div class="recruit-page">
    <section class="recruit-section">
      <h2 class="recruit-section__title">{{ $t('recruit.introTitle') }}</h2>
      <p class="recruit-section__subtitle">{{ $t('recruit.introSubtitle') }}</p>
      <article class="recruit-card">
        <p class="recruit-card__text">{{ $t('recruit.introBody') }}</p>
      </article>
    </section>

    <section class="recruit-section">
      <h2 class="recruit-section__title">{{ $t('recruit.typesTitle') }}</h2>
      <p class="recruit-section__subtitle">{{ $t('recruit.typesSubtitle') }}</p>
      <article class="recruit-card recruit-card--games">
        <img class="recruit-games-img" :src="gameImg" :alt="$t('recruit.typesTitle')">
      </article>
    </section>

    <section class="recruit-section">
      <h2 class="recruit-section__title">{{ $t('recruit.servicesTitle') }}</h2>
      <p class="recruit-section__subtitle">{{ $t('recruit.servicesSubtitle') }}</p>
      <article class="recruit-card">
        <div class="service-list">
          <ul class="service-list__col">
            <li v-for="item in serviceLeft" :key="item">{{ item }}</li>
          </ul>
          <ul class="service-list__col">
            <li v-for="item in serviceRight" :key="item">{{ item }}</li>
          </ul>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import gameImg from '@/assets/游戏.png'

export default {
  name: 'RecruitPage',
  data() {
    return {
      gameImg
    }
  },
  computed: {
    serviceLeft() {
      return [
        this.$t('recruit.service1'),
        this.$t('recruit.service2'),
        this.$t('recruit.service3'),
        this.$t('recruit.service4')
      ]
    },
    serviceRight() {
      return [
        this.$t('recruit.service5'),
        this.$t('recruit.service6'),
        this.$t('recruit.service7'),
        this.$t('recruit.service8')
      ]
    }
  }
}
</script>

<style scoped>
.recruit-page {
  width: 100%;
  padding-bottom: 24px;
}

.recruit-section + .recruit-section {
  margin-top: 42px;
}

.recruit-section__title {
  margin: 0;
  color: #1f2d3d;
  font-size: clamp(24px, 3.2vw, 32px);
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  letter-spacing: -0.02em;
}

.recruit-section__subtitle {
  max-width: 760px;
  margin: 12px auto 0;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  text-align: center;
}

.recruit-card {
  margin-top: 22px;
  padding: 28px 32px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.16);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);
}

.recruit-card__text {
  margin: 0;
  color: #334155;
  font-size: 15px;
  line-height: 1.95;
  text-align: justify;
  text-indent: 2em;
}

.recruit-card--games {
  padding: 20px;
}

.recruit-games-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 12px;
}

.service-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 40px;
}

.service-list__col {
  margin: 0;
  padding: 0;
  list-style: none;
}

.service-list__col li {
  position: relative;
  padding-left: 16px;
  color: #2563eb;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.85;
}

.service-list__col li + li {
  margin-top: 8px;
}

.service-list__col li::before {
  position: absolute;
  left: 0;
  top: 0.72em;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2563eb;
  content: '';
  transform: translateY(-50%);
}

@media (max-width: 640px) {
  .recruit-card {
    padding: 20px 18px;
  }

  .recruit-card__text {
    font-size: 14px;
    text-indent: 0;
  }

  .service-list {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .service-list__col + .service-list__col {
    margin-top: 8px;
  }
}
</style>
